export default __webpack_public_path__ + "static/media/soft19.babcb3ca.jpg";